'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _reject3 = require('lodash/reject');

var _reject4 = _interopRequireDefault(_reject3);

exports.default = reducer;
exports.qsCreate = qsCreate;
exports.loadBox = loadBox;
exports.qsSave = qsSave;
exports.isLoaded = isLoaded;
exports.qsDelete = qsDelete;
exports.toggleBoxView = toggleBoxView;
exports.setOutdated = setOutdated;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

var _datetime = require('helpers/datetime');

var _projects = require('helpers/projects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOGGLE_BOX_VIEW = 'quicksend/TOGGLE_BOX_VIEW';
var SET_OUTDATED = 'quicksend/SET_OUTDATED';
var LOADED_BOX_TYPE = 'quicksend/LOADED_BOX_TYPE';

var loadReducer = (0, _loadReducer2.default)('playlist', {
  qsCreate: {},
  qsList: { action: 'load', init: null },
  qsSave: {},
  qsDelete: {}
});

var initialState = (0, _extends3.default)({}, loadReducer.initialState, {
  boxView: 'box',
  loadedBoxType: _projects.quickSendBox.inbox
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'RESET':
      return initialState;
    case loadReducer.constants.QS_DELETE_SUCCESS:
      if (state.qsListData.albums) {
        return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
          qsListData: (0, _extends3.default)({}, state.qsListData, {
            albums: (0, _reject4.default)(state.qsListData.albums, { project_id: action.qsId })
          })
        });
      }
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        qsListData: (0, _reject4.default)(state.qsListData, { projectId: action.qsId })
      });
    case loadReducer.constants.LOAD_QS_LIST:
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        boxView: 'box'
      });
    case loadReducer.constants.LOAD_QS_LIST_SUCCESS:
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        loadedBoxType: action.box
      });
    case TOGGLE_BOX_VIEW:
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        boxView: action.boxView || (state.boxView === 'box' ? 'item' : 'box')
      });
    case SET_OUTDATED:
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        qsListLoaded: false
      });
    case LOADED_BOX_TYPE:
      {
        return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
          loadedBoxType: action.box
        });
      }
    default:
      return loadReducer.reducer(state, action);
  }
}

function qsCreate() {
  return {
    types: loadReducer.constantsByKey.qsCreate,
    promise: function promise(client) {
      return client.post('project_wa/createQS');
    }
  };
}

function loadBox(box) {
  return function (dispatch) {
    return dispatch({
      types: loadReducer.constantsByKey.qsList,
      promise: function promise(client) {
        return client.post('project_wa/getQSBox', { data: { box: box } });
      },
      box: box
    });
  };
}

function qsSave() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  data.daySavingLight = (0, _datetime.isDaySavingLight)();
  data.timeDifference = (0, _datetime.getTimeDifference)();

  return (0, _extends3.default)({
    types: loadReducer.constantsByKey.qsSave,
    promise: function promise(client) {
      return client.post('project_wa/setQSInfo', { data: data });
    }
  }, data);
}

function isLoaded(type, state) {
  return state.quicksend.qsListLoaded && state.quicksend.qsListActionData.box === type;
}

function qsDelete(qsId) {
  return {
    types: loadReducer.constantsByKey.qsDelete,
    promise: function promise(client) {
      return client.post('project_wa/deleteProject', { data: { projectId: qsId } });
    },
    qsId: qsId
  };
}

function toggleBoxView(boxView) {
  return {
    type: TOGGLE_BOX_VIEW,
    boxView: boxView
  };
}

function setOutdated() {
  return {
    type: SET_OUTDATED
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/quicksend.js
// module id = 156
// module chunks = 1